/**
 * Autocomplete Service
 * AI tabanlı metin tamamlama servisi
 */

import api from '../lib/api';

export interface AutocompleteContext {
  ticketSubject?: string;
  customerName?: string;
  previousMessages?: string;
}

export interface AutocompleteResponse {
  success: boolean;
  data: {
    suggestion: string;
  };
}

class AutocompleteService {
  /**
   * Metin tamamlama önerisi al
   */
  async getSuggestion(text: string, context?: AutocompleteContext): Promise<string> {
    try {
      const response = await api.post<AutocompleteResponse>('/autocomplete', {
        text,
        context
      });
      return response.data.data.suggestion || '';
    } catch (error) {
      console.error('Autocomplete error:', error);
      return '';
    }
  }
}

export default new AutocompleteService();
